interface BuildCapitalCustomValuesArgs {
  baseOptions?: number[];
  gapCapital: number | null;
  minCapital: number;
  maxCapital: number;
}

export const buildCapitalCustomValues = ({
  baseOptions,
  gapCapital,
  minCapital,
  maxCapital,
}: BuildCapitalCustomValuesArgs): number[] | undefined => {
  if (!maxCapital) return baseOptions;

  const gapIsValid =
    gapCapital !== null && gapCapital >= minCapital && gapCapital <= maxCapital;
  if (!gapIsValid) return baseOptions;

  const step = maxCapital / 5;
  const defaults = baseOptions ?? [
    minCapital,
    step,
    step * 2,
    step * 3,
    step * 4,
    maxCapital,
  ];

  const merged = Array.from(new Set([...defaults, gapCapital]));
  return merged.sort((a, b) => a - b);
};
